import _extends from "@babel/runtime/helpers/esm/extends";
import React, { forwardRef } from 'react';
import MenuItem from "@mui/material/MenuItem/MenuItem.js";
import { jsx as _jsx } from "react/jsx-runtime";
/**
 * A Menu link component for the NavBar
 */
var MenuLink = /*#__PURE__*/forwardRef(function (props, ref) {
  return /*#__PURE__*/_jsx(MenuItem, _extends({
    ref: ref,
    component: "a",
    target: "_blank",
    rel: "noreferrer noopener"
  }, props));
});
export default MenuLink;